/* import __COLOCATED_TEMPLATE__ from './time-ago-pop-over.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

export default class TimeAgoPopOverComponent extends Component {
  @tracked isHovered = false;

  @action
  startHover() {
    this.isHovered = true;
  }

  @action
  endHover() {
    this.isHovered = false;
  }
}
